import axiosService from './common/axios'

const api = {
  searchWordCloud: function (keyword, paramData) {
    return axiosService.get('wordCloud/v1.0/words/' + keyword, { params: paramData })
  }
}

export default api
